const EditIcon = ({ className = "" }) => (
  <svg aria-hidden="true" className={className} fill="none" viewBox="0 0 24 24">
    <path
      d="m14.5 5.5 4 4M4.75 19.25l4.1-.55a2 2 0 0 0 1.08-.53L19.5 8.6a2 2 0 0 0 0-2.83l-1.27-1.27a2 2 0 0 0-2.83 0L6.39 12.01a2 2 0 0 0-.53 1.07l-.55 4.17Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
    />
  </svg>
);

export default EditIcon;
